import { createReducer } from '@reduxjs/toolkit';

import { InvoiceData, PageOptions } from '../../types/invoice';
import { DEFAULT_PAGINATION_DATA } from '../../utils';
import { getInvoices, setFilter, setOptions } from '../actions/invoice';

const INITIAL_STATE = {
  loading: false,
  list: [] as InvoiceData[],
  options: {
    filters: {
      filter: '',
    },
    orderBy: 'id',
  } as PageOptions,
  pagination: DEFAULT_PAGINATION_DATA,
};

export const reducer = createReducer(INITIAL_STATE, builder => {
  builder
    .addCase(getInvoices.pending, state => {
      state.loading = true;
    })
    .addCase(getInvoices.rejected, state => {
      state.loading = false;
    })
    .addCase(getInvoices.fulfilled, (state, { payload }) => {
      if (payload) {
        if (payload.meta.pagination.page === 1) {
          state.list = payload.data;
        } else {
          state.list = [...state.list, ...payload.data];
        }
        state.pagination = payload.meta.pagination;
      }
      state.loading = false;
    })
    .addCase(setOptions, (state, { payload }) => {
      state.options = payload;
    })
    .addCase(setFilter, (state, { payload }) => {
      state.options.filters.filter = payload;
    });
});
